import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IExportRequest } from "interfaces/export-duck";
import { requestErrorHandler } from "utils";
import { ExportUsersActions } from 'store/ducks/settings/users';

export function* exportUsersRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IExportRequest;
    const queryString = queryBuilder(query);

    const { data } = yield call(apiGeneral.get, `/users/export?${queryString}`);

    yield put(ExportUsersActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ExportUsersActions.failure(errorMessage));
  }
}
